import React from 'react'
import C from '../Const'
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from '../recharts'
import U from '../Utils'

function ChartSaldoCumulato(props) {
  let { series, data, print } = props
  let { saldo_cumulato } = data

  // converto valori week in data e calcolo la somma cumulativa
  saldo_cumulato.forEach((item) => {
    // FIXME problema grafico: https://github.com/recharts/recharts/issues/876
    // item.date = new Date(item.week)
    item.label = item.week === '0000-00-00' ? '' : item.week.replace(/^(\d+)-0?(\d+)-.*/, '$2/$1')
  })

  let colors = series.length > 1 ? [C.BLUE, C.RED] : [C.BLUE]

  return (
    <ResponsiveContainer aspect={C.ASPECT} className="ChartSaldoCumulato">
      <LineChart data={saldo_cumulato}>
        <CartesianGrid strokeDasharray="5 5" />
        <XAxis dataKey="label" />
        <YAxis type="number" tickFormatter={U.formatNumberPlus} />
        <Tooltip formatter={U.formatNumberPlus} />
        {series.map((ser, s) => (
          <Line
            key={s}
            dataKey={'val' + ser.suf}
            dot={false}
            stroke={colors[s]}
            strokeWidth={2}
            name={'Saldo cumulato ' + ser.name}
            isAnimationActive={!print}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  )
}

export default ChartSaldoCumulato



// WEBPACK FOOTER //
// ./src/main/ChartSaldoCumulato.js